<template>
    <div class="margin">
        <div class="row tit_page">
			<div class="col-12">
				<div class="float-left">
					<h1>Documentos</h1>
				</div>
				<div class="back float-right">
					<a @click="$router.go(-1)" href="javascript:;" title="Voltar">
						<i>&nbsp;</i> voltar
					</a>
				</div>
				<div class="clearfix"></div>
			</div>
        </div>
        <hr class="divider">

        <div class="row">
            <div class="col-12">
                <div class="box-td">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col" class="align-middle text-left">
                                        Nome
                                    </th>
                                    <th scope="col" class="align-middle text-left">
                                        Documento
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        Enviado
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        &nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="response">
                            
                                <!-- COMPROVANTE DE ENDERECO -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosComprovanteEndereco.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                        Comprovante de endereço
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosComprovanteEndereco, 'Comprovante de Endereço', 'ArquivosComprovanteEndereco')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosComprovanteEndereco" :key="documento.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>

                                    <td class="align-middle text-left">
                                        Comprovante de endereço
                                    </td>
                                    
                                    <td class="align-middle text-center">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>

                                    <td class="align-middle text-center">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'Comprovante de Endereço', 'ArquivosComprovanteEndereco')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>   
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>
                                    </td>
                                </tr>
                                
                                <!-- FATURAMENTO -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosFaturamento.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                        Contrato Social
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosFaturamento, 'Faturamento', 'ArquivosFaturamento')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosFaturamento" :key="documento.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>

                                    <td class="align-middle text-left">
                                        Faturamento
                                    </td>
                                    
                                    <td class="align-middle text-center">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>

                                    <td class="align-middle text-center">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'Faturamento', 'ArquivosFaturamento')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>   
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>
                                    </td>
                                </tr>

                                <!-- CONTRATO SOCIAL -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosContratoSocial.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                        Contrato Social
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosContratoSocial, 'Contrato Social', 'ArquivosContratoSocial')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosContratoSocial" :key="documento.Nome">
                                    <td class="align-middle text-left"  v-if="ArquivosContratoSocial.length > 0">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        Contrato Social
                                    </td>
                                    <td class="align-middle text-center" v-if="ArquivosContratoSocial.length > 0">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>
                                    <td class="align-middle text-center" v-if="ArquivosContratoSocial.length > 0">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'Contrato Social', 'ArquivosContratoSocial')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>
                                    </td>
                                </tr>
                                
                                <!-- EXTRATOS BANCARIOS -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosUltimosExtratosBancarios.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                        Extratos Bancários
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosUltimosExtratosBancarios, 'Extratos Bancários', 'ArquivosUltimosExtratosBancarios')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosUltimosExtratosBancarios" :key="documento.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        Extratos Bancários
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'Extratos Bancários', 'ArquivosUltimosExtratosBancarios')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>    
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>                                          
                                    </td>
                                </tr>

                                <!-- IRPF -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosIrpf.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                        IRPF
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosIrpf, 'IRPF', 'ArquivosIrpf')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosIrpf" :key="documento.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        IRPF
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'IRPF', 'ArquivosIrpf')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>      
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>                                               
                                    </td>
                                </tr>

                                <!-- IDENTIDADE -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosIdentidade.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                        Identidade
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosIdentidade, 'Identidade', 'ArquivosIdentidade')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosIdentidade" :key="documento.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        Identidade
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'Identidade', 'ArquivosIdentidade')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>     
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>                                           
                                    </td>
                                </tr>

                                <!-- IDENTIDADE -->
                                <!-- VERIFICA SE O DOCUMENTO NÃO FOI ENVIADO OU O ARRAY DO DOCUMENTO ESTÁ VAZIO -->
                                <tr v-if="ArquivosBalancoEDre.length <= 0">
                                     <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>                        
                                        Arquivo não enviado
                                    </td>
                                    <td class="align-middle text-left">
                                         Balanço e DRE
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                        <a id="show-modal" @click="exibeModal(ArquivosIdentidade, 'Balanço e DRE', 'ArquivosBalancoEDre')" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a> 
                                    </td>
                                </tr>
                                <!-- OR -->
                                <tr v-for="documento in ArquivosBalancoEDre" :key="documento.Nome">
                                    <td class="align-middle text-left">
                                        <i v-if="documento.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="documento.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(documento.MetaDados.NomeArquivo) }} 
                                        <span v-if="documento.Status == '' || documento.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="documento.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        Balanço e DRE
                                    </td>
                                    <td class="align-middle text-center">
                                        {{ formatDate(documento.DataEnvio) }}
                                    </td>
                                    <td class="align-middle text-center">
                                        <a v-if="documento.Status != 'APROVADO'" id="show-modal" @click="exibeModal(documento, 'Balanço e DRE', 'ArquivosBalancoEDre')" class="td-link">
                                            <i class="icon icon-send-file sm"></i>
                                            <span>Enviar documento</span>
                                        </a>     
                                        <a v-bind:href="uploadEndpoint + documento.Nome" target="_blank" class="td-link">
                                            <i class="icon icon-eye-2 md"></i>
                                            <span>Visualizar</span>
                                        </a>    
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <div class="float-left others" v-if="renderOutros">
                            <h4>Outros Documentos</h4>
                        </div>
                        <table class="table" v-if="renderOutros">
                            <thead>
                                <tr>
                                    <th scope="col" class="align-middle text-left">
                                        Nome
                                    </th>
                                    <th scope="col" class="align-middle text-left">
                                        Documento
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        Enviado
                                    </th>
                                    <th scope="col" class="align-middle text-center">
                                        &nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="renderOutros" v-for="outro in outros" :key="outro._id">
                                <!-- ============================= DOCUMENTO A SER ENVIADO ======================== -->
                                <tr v-if="outro.Documento.length <= 0">
                                    <td class="align-middle text-left">
                                        <i class="icon icon-doc-atencao md"></i>
                                        <span class="badge badge-danger">enviar</span>
                                    </td>
                                    <td class="align-middle text-left">
                                        {{outro.NomeDocumento}}
                                    </td>
                                    <td class="align-middle text-center">
                                        -
                                    </td>
                                    <td class="align-middle text-center">
                                    <a class="td-link" @click="exibeModalOutros(outro._id, outro.NomeDocumento)">
                                        <i class="icon icon-send-file sm"></i>
                                        <span>Enviar documento</span>
                                    </a>     
                                    <a class="td-link">
                                        <span>-</span>
                                    </a>    
                                  </td>
                                </tr>
                                <!-- ========================== :::::::::: =========================== -->
                                <!-- ========================== DOCUMENTO JA ENVIADO ============================== -->
                                <tr v-else-if="outro.Documento.length > 0" v-for="doc in outro.Documento" :key="doc.Nome">
                                   <td class="align-middle text-left">
                                        <i v-if="doc.Status == 'APROVADO'" class="icon icon-doc-ok md"></i>
                                        <i v-else-if="doc.Status != 'APROVADO'" class="icon icon-doc-atencao md"></i>                        
                                        {{ nomeArquivo(doc.MetaDados.NomeArquivo) }} 
                                        <span v-if="doc.Status == '' || doc.Status == undefined" class="badge badge-warning">Em análise</span>
                                        <span v-else-if="doc.Status == 'REPROVADO'" class="badge badge-danger">Reenviar</span>
                                   </td>
                                   <td class="align-middle text-left">
                                       {{outro.NomeDocumento}}
                                  </td>
                                  <td class="align-middle text-center">
                                        {{ formatDate(doc.DataEnvio) }}
                                  </td>
                                  <td class="align-middle text-center">
                                    <a v-if="doc.Status != 'APROVADO'" id="show-modal" @click="exibeModalOutros(outro._id, outro.NomeDocumento)" class="td-link">
                                        <i class="icon icon-send-file sm"></i>
                                        <span>Enviar documento</span>
                                    </a>     
                                    <a v-bind:href="uploadEndpoint + doc.Nome" target="_blank" class="td-link">
                                        <i class="icon icon-eye-2 md"></i>
                                        <span>Visualizar</span>
                                    </a>    
                                  </td> 
                                </tr>
                                <!-- ============================= :::::::: ================================= -->
                            </tbody>
                        </table>
                    </div>

                    <modal v-if="showModal" class="modal-invited" @close="closeModal()">
                        <div slot="header">
                            <div class="tit float-left">
                            <h2 style="padding-right:50px;">
                                <i class="icon icon-airplane xl"></i>
                                Enviar {{ tipoArquivoSelecionado }}
                            </h2>
                            </div>
                        </div>
                        <div slot="body" style="overflow-x: auto;">
                            <!-- documento enviado com sucesso -->
                            <div v-if="submitted" class="success d-flex flex-column justify-content-center align-items-center">
                                <i class="icon icon-success xll"></i>
                                <h3>Documento enviado com sucesso!</h3>
                            </div>
                            <!-- ***************************** -->

                            <div v-else>
                                <files-input :files="files" :accept="acceptedFormats"
                                    :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
                                <br />
                                <div class="float-md-right">
                                    <button class="btn btn-primary" style="color: #fff !important;"  @click="submit()">Enviar Documentos</button>            
                                </div>
                            </div>
                            <br/> 
                        </div>
                        
                    </modal>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../assets/styles/iouu/mixins";
    @import "../../assets/styles/iouu/list-documents";

    @include xs {
        .btn-exit{
            position: absolute;
            top: 2px!important;
            right: 2px!important;
        }
        .btn {
            width: 100%;
        }
    }
    .others {
        margin-top: 2rem;
    }
</style>

<script>
    import ApiClient from '../../utils/api-client';
    import Modal from '@/components/Modal'
    import FilesInput from '@/components/FilesInput'
    import ArrayHelper from '@/utils/array-helper'

    export default {
        components: { Modal, FilesInput },
        data() {
            return {
                response: false,
                showModal: false,
                submitted: false,
                created: {},
                ArquivosFaturamento: {},
                ArquivosContratoSocial: {},
                ArquivosUltimosExtratosBancarios: {},
                ArquivosIrpf: {},
                ArquivosIdentidade: {},
                ArquivosBalancoEDre: {},
                ArquivosComprovanteEndereco: {},
                tipoArquivoSelecionado: "",
                campoArquivoMongodb: "",
                nomeArquivoSelecionado: "",
                idArquivoSelecionado: "",
                /* eslint-disable */ 
                uploadEndpoint: process.env.API_NODE+'/files',
                acceptedFormats: 'application/pdf, image/jpeg, image/png',
                files: [null],
                outros: [],
                renderOutros: false,
                OutrosModal: false,
            }
        },
        methods: {
            formatDate(data) {
                let dataForm = new Date(data);
                let dia = dataForm.getDate();

                if (dia.toString().length == 1)
                    dia = "0" + dia;

                let mes = dataForm.getMonth() + 1;

                if (mes.toString().length == 1)
                    mes = "0" + mes;

                let ano = dataForm.getFullYear();

                if(isNaN(parseInt(ano))|| isNaN(parseInt(mes)) || isNaN(parseInt(dia))) {
                    
                    return this.formatDate(this.created);
                }

                return dia + "/" + mes + "/" + ano; 
            },

            exibeModal(arquivo, tipoArquivoSelecionado, campoNome) {
                this.files = [null];
                this.submitted = false;                
                this.showModal = true;

                this.tipoArquivoSelecionado = tipoArquivoSelecionado;
                this.nomeArquivoSelecionado = arquivo.Nome;
                this.campoArquivoMongodb = campoNome;

                if(document.getElementsByTagName("main").length > 0 ){
                     document.getElementsByTagName("main")[0].style.zIndex = "50";
                }
            },

            exibeModalOutros(id, tipoArquivoSelecionado) {
                this.files = [null];
                this.submitted = false;                
                this.showModal = true;
                this.OutrosModal = true;

                this.tipoArquivoSelecionado = tipoArquivoSelecionado;
                this.idArquivoSelecionado = id;

                if(document.getElementsByTagName("main").length > 0 ){
                     document.getElementsByTagName("main")[0].style.zIndex = "50";
                }
            },

            onFilesChanged(updatedFiles) {
                this.files = updatedFiles
            },

            removeFile(index) {
                this.files.splice(index, 1)
            },

            clearFile(index) {
                this.$set(this.files, index, null)
            },

            validate() {
                if(this.receivedFiles.length > 0) {
                    return {isValid: true, errors: []}
                } else {
                    return {isValid: false, errors: ['O envio do documento de identidade é obrigatório']}
                }
            },

            submit() {
                const validation = this.validate()

                if(validation.isValid) {
                    this.submitted = true;
                    if(this.OutrosModal) {
                        ApiClient.postDocumentosSolicitacao(this.idArquivoSelecionado,this.getId, this.receivedFiles)
                        .then(() => {})
                    } else {
                        ApiClient.createDocumentos(this.getType, this.campoArquivoMongodb, this.getId, this.nomeArquivoSelecionado,  this.receivedFiles)
                        .then(() => {})
                    }
                } else {
                    this.$Notify.error({
                    title: "Dados Inválidos",
                    message: ArrayHelper.toSentence(validation.errors)})
                }
            },

            closeModal() {
                this.showModal = false;
                this.OutrosModal = false;
                
                ApiClient.getDocumentos(this.getType, this.getId)
                    .then(response => {
                        this.ArquivosFaturamento = response.data.ArquivosFaturamento;
                        this.ArquivosContratoSocial = response.data.ArquivosContratoSocial;
                        this.ArquivosUltimosExtratosBancarios = response.data.ArquivosUltimosExtratosBancarios;
                        this.ArquivosIrpf = response.data.ArquivosIrpf;
                        this.ArquivosIdentidade = response.data.ArquivosIdentidade;
                        this.ArquivosBalancoEDre = response.data.ArquivosBalancoEDre;
                        this.ArquivosComprovanteEndereco = response.data.ArquivosComprovanteEndereco;
                        this.created = response.data.Created;
                        this.response = true;
                    });
                    if(document.getElementsByTagName("main").length > 0 ){
                        document.getElementsByTagName("main")[0].style.zIndex = "0";
                    }

                ApiClient.getDocumentosSolicitacao(this.getId)
                .then(response => {
                    this.outros = response.data;

                    if(this.outros.length > 0) {
                        this.renderOutros = true;
                    }
                })
            },
            
        nomeArquivo(arquivo){
            if(arquivo.length > 22){
                var extensao = arquivo.substr(arquivo.lastIndexOf("."))
                var nome = arquivo.substr(0,arquivo.lastIndexOf("."))

                return nome.substr(0,15)+"..." + extensao;

            }

            return arquivo;
        }

        },
        props: ['type', 'id'],

        created() {

            ApiClient.getDocumentos(this.getType, this.getId)
                .then(response => {
                    this.ArquivosFaturamento = response.data.ArquivosFaturamento;
                    this.ArquivosContratoSocial = response.data.ArquivosContratoSocial;
                    this.ArquivosUltimosExtratosBancarios = response.data.ArquivosUltimosExtratosBancarios;
                    this.ArquivosIrpf = response.data.ArquivosIrpf;
                    this.ArquivosIdentidade = response.data.ArquivosIdentidade;
                    this.ArquivosBalancoEDre = response.data.ArquivosBalancoEDre;
                    this.ArquivosComprovanteEndereco = response.data.ArquivosComprovanteEndereco;
                    this.created = response.data.Created;
                    this.response = true;
                });

            ApiClient.getDocumentosSolicitacao(this.getId)
            .then(response => {
                this.outros = response.data;

                if(this.outros.length > 0) {
                    this.renderOutros = true;
                }
            })
        },

        computed: {
            getType() {
                return this.type;
            },

            getId() {
                return this.id;
            },

            receivedFiles() {
                return this.files.filter(file => {
                    return file != null && file != undefined
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Documentos/DocumentosEmprestimoColetivo.vue